var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_92",
    "data-name": "Group 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.38,
    height: 80,
    viewBox: "0 0 70.38 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69100",
    "data-name": "Path 69100",
    d: "M1.8,65.387l-.727,2.084,31.6,18.241A49.219,49.219,0,0,1,21.2,54.315l-.048-13.231A46.947,46.947,0,0,0,1.8,65.387",
    transform: "translate(-1.077 -41.084)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69101",
    "data-name": "Path 69101",
    d: "M34.747,0,3.992,17.757a49.209,49.209,0,0,1,32.451,6.155l11.318,6.626A46.949,46.949,0,0,0,36.025,1.446Z",
    transform: "translate(-3.992)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69102",
    "data-name": "Path 69102",
    d: "M2.013,24.024,0,24.412V60.374A49.215,49.215,0,0,1,21.731,35.1l11.3-6.394A46.942,46.942,0,0,0,2.013,24.024",
    transform: "translate(0 -23.172)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69103",
    "data-name": "Path 69103",
    d: "M56.735,32.567,56.783,45.8A46.946,46.946,0,0,0,76.132,21.5l.729-2.093L45.247,1.152A49.215,49.215,0,0,1,56.735,32.567",
    transform: "translate(-45.247 -1.152)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69104",
    "data-name": "Path 69104",
    d: "M39.573,88.151l1.214,1.374L71.339,71.887a49.181,49.181,0,0,1-32.184-6.2L27.838,59.06A46.946,46.946,0,0,0,39.573,88.151",
    transform: "translate(-27.838 -59.06)",
    fill: "#61cafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69105",
    "data-name": "Path 69105",
    d: "M55.933,53.259l-11.3,6.394a46.946,46.946,0,0,0,31.015,4.682l1.927-.372V28.214A49.218,49.218,0,0,1,55.933,53.259",
    transform: "translate(-44.636 -28.214)",
    fill: "#61cafa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0.903 34.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 49.321,
    height: 38.675,
    transform: "translate(-7.424 43.357) rotate(-80.283)",
    fill: "#61cafa"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(3.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 53.352,
    height: 49.613,
    transform: "translate(-14.049 9.289) rotate(-33.473)",
    fill: "#61cafa"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 19.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 40.011,
    height: 43.23,
    transform: "translate(-7.531 1.593) rotate(-11.941)",
    fill: "#61cafa"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(37.95 0.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 51.775,
    height: 42.969,
    transform: "matrix(0.283, -0.959, 0.959, 0.283, -12.132, 41.063)",
    fill: "#61cafa"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(23.348 49.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 51.117,
    height: 52.962,
    transform: "matrix(0.633, -0.774, 0.774, 0.633, -14.927, 18.266)",
    fill: "#61cafa"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(37.437 23.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 40.866,
    height: 44.742,
    transform: "translate(-8.575 2.035) rotate(-13.352)",
    fill: "#61cafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSentiment);
export default __webpack_public_path__ + "static/media/ai_sentiment.4e90827320a7d674c43fec27587b3427.svg";
export { ForwardRef as ReactComponent };